export default __webpack_public_path__ + "static/media/coach.b04ba923.png";